/**
 * Modul Cart
 */

import {
	needJquery,
	getTransitionDuration, extend
} from '../../../shared/utils/index';


import SelectorEngine from '../../../shared/dom/selector-engine';
import Manipulator from "../../../shared/dom/manipulator";

// Cart Components
import Adresses from "./adresses";
import Events from "./events";

// ------
// Public
// ------

const init = () => {
	Adresses.init();
	Events.init();
};

// ------
// Export
// ------

export default {
	init : init
};